import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultStyles from './MonthPicker.module.css';
import jlrStyles from './MonthPickerJlr.module.css';
import {
  getMonthNameWithYear,
  setStylesAccordingToPlant,
} from '../../utils/utils';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';

const MonthPicker = ({ handleSelect, hideArrow, activeMonthNameWithYear }) => {
  const today = moment();
  const nextThreeMonthNamesWithYear = [
    'thisMonth',
    'nextMonth',
    'thirdMonth',
  ].map(() => {
    const monthAndYear = getMonthNameWithYear(today);
    today.add(1, 'months');
    return monthAndYear;
  });
  const previousMonthWithYear = getMonthNameWithYear(
    moment().subtract(1, 'months'),
  );
  const allMonths = [previousMonthWithYear, ...nextThreeMonthNamesWithYear];

  const [selectedMonthNameWithYear, setSelectedMonthNameWithYear] = useState(
    activeMonthNameWithYear || nextThreeMonthNamesWithYear[0],
  );

  const [styles, setStyles] = useState(defaultStyles);
  const [plant] = usePlantAndLinesStore().plantState;

  const handleClick = monthString => {
    const selectSuccess = handleSelect(monthString);
    if (selectSuccess) setSelectedMonthNameWithYear(monthString);
  };

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <div className={styles.selectMonth}>
      <span className={styles.monthView}>View</span>

      <ul
        className={
          hideArrow ? clsx(styles.months, styles.hideArrow) : styles.months
        }
      >
        {allMonths.map(monthNameWithYear => (
          <li
            className={clsx(
              monthNameWithYear === selectedMonthNameWithYear && styles.active,
            )}
            onClick={() => handleClick(monthNameWithYear)}
            key={monthNameWithYear}
          >
            {monthNameWithYear && monthNameWithYear?.split('-')[0]}
          </li>
        ))}
      </ul>
    </div>
  );
};

MonthPicker.propTypes = {
  handleSelect: PropTypes.func.isRequired,
  hideArrow: PropTypes.bool,
  activeMonthNameWithYear: PropTypes.string.isRequired,
};

export default MonthPicker;
